import {
    Component, inject
} from "@angular/core";
import { MatButton } from "@angular/material/button";
import { APP_ROUTER_SERVICE } from "../../constants/app-tokens";
import { ButtonDirective } from "../../directives/button/button.directive";

@Component({
    selector: "mgd-error-page",
    templateUrl: "./error-page.component.html",
    styleUrls: ["./error-page.component.scss"],
    imports: [MatButton, ButtonDirective]
})
export class ErrorPageComponent {

    private readonly _appRouter = inject(APP_ROUTER_SERVICE);

    /**
     * Returns the error message associated with the current route
     *
     * If its not there, the template will show a default message
     */
    get errorMessage(): string {

        return this._appRouter.errorMessage;
    }

    /**
     * Call back for back button click
     */
    onBack(): void {

        this._appRouter.toRoot();
    }
}
